
  import { Button } from '@/ui/components/Button';

  export default {
    components: {
      Button,
    },
  };
